import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { CLASS_COLORS, slug } from "@/lib/customCalc";

const EMOJIS = ["🧒", "🎒", "📘", "🎓", "👧", "👦", "🏫", "📚"];

export default function StepClasses({ cfg, set, b }) {
  const upd = (i, patch) => set((c) => ({ ...c, classes: c.classes.map((x, j) => (j === i ? { ...x, ...patch } : x)) }));
  const add = () => set((c) => {
    const n = c.classes.length;
    const key = slug(`class_${n + 1}`, c.classes.map((x) => x.key));
    return { ...c, classes: [...c.classes, { key, name: "", name_local: "", color: CLASS_COLORS[n % 8], emoji: EMOJIS[n % 8] }] };
  });
  const remove = (i) => set((c) => {
    const key = c.classes[i].key;
    const periods = c.periods.map((p) => { const cl = { ...(p.classes || {}) }; delete cl[key]; return { ...p, classes: cl }; });
    return { ...c, classes: c.classes.filter((_, j) => j !== i), periods };
  });
  return (
    <div className="space-y-3" data-testid="step-classes">
      {cfg.classes.map((cl, i) => (
        <div key={cl.key} className="rounded-2xl bg-white border border-thali-turmeric/30 p-3 space-y-2" style={{ borderLeft: `6px solid ${cl.color}` }} data-testid={`b-class-${i}`}>
          <div className="flex gap-2">
            <select className="input-thali w-16 px-1 text-center" value={cl.emoji} onChange={(e) => upd(i, { emoji: e.target.value })} aria-label="icon" data-testid={`b-class-emoji-${i}`}>
              {EMOJIS.map((em) => <option key={em}>{em}</option>)}
            </select>
            <input className="input-thali flex-1" placeholder={b("class_name")} value={cl.name} maxLength={60}
              onChange={(e) => upd(i, { name: e.target.value })} data-testid={`b-class-name-${i}`} />
            <button onClick={() => remove(i)} className="w-12 shrink-0 rounded-xl text-red-600 hover:bg-red-50 grid place-items-center" aria-label={b("remove")} data-testid={`b-class-remove-${i}`}><Trash2 className="w-5 h-5" /></button>
          </div>
          <input className="input-thali" placeholder={b("local_name")} value={cl.name_local || ""} maxLength={60}
            onChange={(e) => upd(i, { name_local: e.target.value })} data-testid={`b-class-local-${i}`} />
          <div className="flex gap-2">
            {CLASS_COLORS.map((col) => (
              <button key={col} onClick={() => upd(i, { color: col })} aria-label={col}
                className={`w-8 h-8 rounded-full transition-transform ${cl.color === col ? "ring-2 ring-offset-2 ring-thali-ink scale-110" : ""}`} style={{ background: col }} />
            ))}
          </div>
        </div>
      ))}
      {cfg.classes.length < 8 && (
        <button onClick={add} className="btn-ghost w-full border-2 border-dashed border-thali-turmeric/50" data-testid="b-add-class"><Plus className="w-4 h-4" /> {b("add_class")}</button>
      )}
    </div>
  );
}
